"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listingsResponse500 = void 0;
exports.listingsResponse500 = {
    statusCode: 500,
    message: 'Internal server error',
};
